<template>
  <div>
    <div class="row">
        <div class="col-md-6 d-flex">
        <button @click="adddata" class="btn-sm btn-outline-secondary ml-2 py-1 px-2 my-2 ">Add Data</button>
        <div class="d-flex col-md-4">
       <!-- New Layout selection drop-down -->
       <label class="mt-auto mb-auto mr-1">Select Layout</label>
       <div class="mt-2 ">
         <select class="form-select py-1" v-model="selectedLayout">
           <option value="dagre">Dagre</option>
           <option value="breadthfirst">Breadthfirst</option>
           <option value="grid">Grid</option>
           <!-- <option value="circle">Circle</option>
           <option value="concentric">Concentric</option> -->
           <option value="cose">Cose</option>
           <!-- <option value="klay">Klay</option> -->
         </select>
       </div>
      </div>
        </div>

      </div>
    <!-- Cytoscape container -->
    <!-- <div id="cy"></div> -->
    <graph ref="childComp" :selectedLayout="selectedLayout" :graphdata="inputgraphdata"  />
<!-- Popup Details Modal -->
<div v-if="adddatapopup" class="modal-wrapper is-visible">
         <div class="modal-container">
          <div class="titleclass">
            <h4 class="px-3 mt-1">Add Data</h4>
            <div class="closebutton mt-1">
              <a style="color: white" class="close-link">
                <i class="fa fa-times" @click.prevent="closeadddata"></i>
              </a>
            </div>
          </div>
          <div class="modelbody p-0">
            <div class="mb-3 p-2">
              <div class="form-group">
                <div class="mb-3 text-center">
  <label for="graphDataInput" class="form-label d-block text-start">
    Add graph data in JSON format
  </label>
  <textarea v-model="enteredgraphdata" class="form-control" id="graphDataInput" rows="7"></textarea>
  <div class="d-flex justify-content-center mt-2">
    <button class="btn btn-primary" @click="graphdataentered()">OK</button>
  </div>
</div>
              </div>
            </div>
          </div>
        </div>
        </div>
  </div>
</template>
<script>
import axios from "axios";
import cytoscape from "cytoscape";
import dagre from "cytoscape-dagre"; // Import the Dagre extension
import store from "@/store";
import klay from "cytoscape-klay";
import graph from "../../custom_lib/graph_lib/graph.vue";

cytoscape.use(dagre); // Register Dagre with Cytoscape
cytoscape.use(klay);

export default {
name: "NetworkXGraph",
components: {
    graph,
  },
data() {
  return {
    selectedLayout:"cose",
    inputgraphdata:"",
    graphdata: {
                "directed": true,
                "multigraph": false,
                "graph": {},
                "nodes": [
                    {
                        "label": "newtestgraph",
                        "properties": {
                            "new prop name": "new prop value"
                        },
                        "id": "67bd5834fd1fbb25438eb7d1"
                    },
                    {
                        "label": "new node",
                        "properties": {},
                        "id": "6b8b44c3-180b-467f-a75a-19a89313fb2a"
                    }
                ],
                "links": [
                    {
                        "label": "new node",
                        "source": "67bd5834fd1fbb25438eb7d1",
                        "target": "6b8b44c3-180b-467f-a75a-19a89313fb2a"
                    }
                ]
              },
    adddatapopup: false,
    enteredgraphdata: "",
  };
},

methods: {
  async adddata(){
      this.adddatapopup = true;
  },
  async closeadddata(){
    this.adddatapopup = false;
  },
  async graphdataentered() {
    this.inputgraphdata = JSON.parse(this.enteredgraphdata);
  this.closeadddata();
},



},
};

</script>
<style scoped>
@import "../../assets/css/style.css";

#cy {
width: 100%;
height: 600px;
border: 1px solid #ddd;
}

.popup-menu {
background: #fff;
border: 1px solid #ccc;
border-radius: 3px;
padding: 5px;
box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.popup-menu ul {
list-style: none;
padding: 0;
margin: 0;
}

.popup-menu li {
padding: 3px 8px;
cursor: pointer;
}

.popup-menu li:hover {
background: #f0f0f0;
}

.modal-wrapper {
position: fixed;
left: 0;
top: 0;
background: rgba(0, 0, 0, 0.5);
height: 100%;
width: 100%;
display: flex;
align-items: center;
justify-content: center;
opacity: 1;
pointer-events: auto;
overflow: hidden;
z-index: 9999;
}

.modal-container {
background: #fff;
width: 80%;
max-width: 600px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
transition: all 0.3s ease-in-out;
}

.is-visible {
opacity: 1;
pointer-events: auto;
}

.table {
width: 100%;
border-collapse: collapse;
text-align: left;
}

.table th,
.table td {
padding: 8px;
border: 1px solid #ddd;
}

.table th {
background-color: #f4f4f9;
font-weight: bold;
}

.table-striped tbody tr:nth-child(odd) {
background-color: #f9f9f9;
}
</style>

